export default "__VITE_ASSET__BrDPO6zL__"